/**
 *
 * DialogTitle
 *
 */

import React, { memo } from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

import CrossIcon from '../../../../../assets/v2/CrossIcon';
import {
  CloseIconContainer,
  StyledDialogTitle,
  StyledTitleContent,
} from './DialogTitle.styles';

function DialogTitle({ children, onClose, ...props }) {
  return (
    <StyledDialogTitle {...props}>
      <StyledTitleContent>{children}</StyledTitleContent>
      {onClose && (
        <CloseIconContainer>
          <Button size="iconSmall" onClick={onClose}>
            <CrossIcon />
          </Button>
        </CloseIconContainer>
      )}
    </StyledDialogTitle>
  );
}

DialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default memo(DialogTitle);
